module.exports = __webpack_public_path__ + "86d05d7c08c30c99ab07f830b8f0011b.png";